<template>

    <div class="bannerBox">
      <el-carousel trigger="click"  height="560px">
          <el-carousel-item v-for="item in ggList" :key="item.id"  >
            <div class = 'bannerContent'>
              <div class = 'banner' :style = " `background:url(' ${commonUrl + item.adverImage} ') no-repeat 50% 50%` " @click = "handleclickbanner(item.linkType,item.linkAddress)">
                <!-- <div class = 'bannerleft'>
                  <img class = 'bannersmall' src="../../../../static/images/bannersmall.svg" alt="">
                </div> -->
              </div>
            </div>
          </el-carousel-item>
      </el-carousel>

      <div class="showList">
        <div class="showData">

          <div class="dataItem">
            <img  class = 'dataImage' src="../../../../static/images/dlbz.svg" alt="">
            <div class="dataRight">
              <div class="righttitle">地理标志产品</div>
              <div class="number"><span>{{ geoIndicaProducts}}</span><a>个</a></div>
            </div>
          </div>
          <div class="dataItem">
            <img  class = 'dataImage' src="../../../../static/images/special.png" alt="">
            <div class="dataRight">
              <div class="righttitle">名特优新农产品</div>
              <div class="number"><span>{{ yxCount}}</span><a>个</a></div>
            </div>
          </div>         
         
          <div class="dataItem">
            <img  class = 'dataImage' src="../../../../static/images/rkyp.svg" alt="">
            <div class="dataRight">
              <div class="righttitle">入库样品总数</div>
              <div class="number"><span>{{ sampNum + geoIndicaProducts}}</span><a>个</a></div>
            </div>
          </div>
          <!-- <div class="dataItem">
            <img  class = 'dataImage' src="../../../../static/images/aqsj.svg" alt="">
            <div class="dataRight">
              <div class="righttitle">安全数据总量</div>
              <div class="number"><span>{{ result.safeNum}}</span><a>个</a></div>
            </div>
          </div> -->
          <div class="dataItem">
            <img  class = 'dataImage' src="../../../../static/images/tzsl.svg" alt="">
            <div class="dataRight">
              <div class="righttitle">特征数据总量</div>
              <div class="number"><span>{{ Number(result.featureNum) + Number(result.safeNum) }}</span><a>个</a></div>
            </div>
          </div>

        </div>
      </div>


    </div>


</template>

<script>

export default {
  mounted() {
   this.getggList()
   this.getnumList()
   this.getdlList()
   this.getrkList()
   this.selMtyxCount()
   this.commonUrl = commonUrl
  },
  data () {
    return {
      commonUrl:'',
      ggList :[],
      result:{},
      geoIndicaProducts:'',
      sampNum:'',
      yxCount:''
    }
  },
  methods: {
    handleclickbanner(linkType,linkAddress){
      if(linkType == '1'){
        window.open(linkAddress)
      }
    },
    getdlList(){
      this.Axios({
        method:"post",
        url:Action.SELGEOCOUNT,
        data:{}
      }).then(res =>{
          if(res.data.code === '000'){
            this.geoIndicaProducts = Number(res.data.result.geoIndicaProducts)
          }else{
              this.$alert(res.data.msg || '系统错误...','错误提示',{
                  cofirmButtonText:'确定',
                  type:'error'
              })
          }
      }).catch(err =>{
              console.log(err)
      })
    },
    getrkList(){
      this.Axios({
        method:"post",
        url:Action.SAMPLECOUNT,
        data:{}
      }).then(res =>{
          if(res.data.code === '000'){
            this.sampNum = Number(res.data.result.sampNum) 
          }else{
              this.$alert(res.data.msg || '系统错误...','错误提示',{
                  cofirmButtonText:'确定',
                  type:'error'
              })
          }
      }).catch(err =>{
              console.log(err)
      })
    },
    selMtyxCount(){
      this.Axios({
        method:"post",
        url:Action.REPLENISH_SELMTYXCOUNT,
        data:{}
      }).then(res =>{
          if(res.data.code === '000'){
            this.yxCount = Number(res.data.result.mtyxCount) 
          }else{
              this.$alert(res.data.msg || '系统错误...','错误提示',{
                  cofirmButtonText:'确定',
                  type:'error'
              })
          }
      }).catch(err =>{
              console.log(err)
      })
    },
    getggList(){
      this.Axios({
        method:"post",
        url:Action.PROTAL_ADVER_LIST,
        data:{
         id:'1'
        }
      }).then(res =>{
          if(res.data.code === '000'){
            this.ggList = res.data.result[0].adverMageListVos
            console.log(this.ggList )
          }else{
              this.$alert(res.data.msg || '系统错误...','错误提示',{
                  cofirmButtonText:'确定',
                  type:'error'
              })
          }
      }).catch(err =>{
              console.log(err)
      })
    },

    getnumList(){
      this.Axios({
        method:"post",
        url:Action.REPLENISH_OVERVIEW,
        data:{
          
        }
      }).then(res =>{
          if(res.data.code === '000'){
           this.result = res.data.result
          }else{
              this.$alert(res.data.msg || '系统错误...','错误提示',{
                  cofirmButtonText:'确定',
                  type:'error'
              })
          }
      }).catch(err =>{
              console.log(err)
      })
    },

  },
  
  
 
}
</script>


<style lang="less" >

  .bannerBox{
    height:560px;
    width:100%;
    position:relative;
    
    .el-carousel__indicators--horizontal {
        bottom: 120px;
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);
    }
    
    .el-carousel__button {
        display: block;
        opacity: .48;
        width: 30px;
        height: 2px;
        background-color: #ccd5de;
        border: none;
        outline: 0;
        padding: 0;
        margin: 0;
        cursor: pointer;
        -webkit-transition: .3s;
        transition: .3s;
    }
      .el-carousel__indicator.is-active button {
        opacity: 1;
        background:#2c6eff!important;
      }
    .bannerContent{
      background:#DCEAFF;
      width:100%;
      .banner{
        // max-width:1920px;
        min-width:1180px;
        height:560px;
        .bannerleft{
            width:1180px;
            height:100%;
            margin: 0 auto;
            .bannersmall{
              width:545px;
              height:210px;
              margin-top:150px;
            }
          }
        // background:url('../../../../static/images/banner1.png') no-repeat 0% 100%;
      }
    }
    .showList{
      position: absolute;
      width:100%;
      height: 94px;
      background-color: #f2f5fa;
      opacity: 0.93;
      bottom:0;
      left:0;
      z-index:100;
      .showData{
        width:1180px;
        padding: 0 80px;
        margin: 0 auto;
        height: 94px;
        display: flex;
        justify-content: space-between;
        .dataItem{
          display: flex;
          align-items: center;
          .dataImage{
            width: 46px;
	          height: 51px;
          }
          .dataRight{
            margin-left:10px;
            .righttitle{
              width: 112px;
              height: 26px;
              font-family: PingFangSC-Medium;
              font-size: 16px;
              font-weight: normal;
              font-stretch: normal;
              line-height: 26px;
              letter-spacing: 0px;
              color: #222222;
              font-weight:900;
            }
            .number{
              span{
                width: 80px;
                height: 26px;
                font-family: DINAlternate-Bold;
                font-size: 30px;
                font-weight: normal;
                font-stretch: normal;
                line-height: 26px;
                letter-spacing: 0px;
                color: #222222;
              }
              .a{
                font-family: PingFangSC-Medium;
                font-size: 16px;
                font-weight: normal;
                letter-spacing: 0px;
                color: #222222;
              }
            }
          }
        }
      }
    }

   
    
  }


</style>



// WEBPACK FOOTER //
// src/views/homePage/compontents/banner.vue